export default __webpack_public_path__ + "static/media/IMG_8808.876e5473.jpg";